import {
  JsonConfiguration2bv2x41u8reet as JsonConfiguration,
  ClassDiscriminatorMode_POLYMORPHIC_getInstancefnov534wisbx as ClassDiscriminatorMode_POLYMORPHIC_getInstance,
} from './JsonConfiguration.mjs';
import { EmptySerializersModule991ju6pz9b79 as EmptySerializersModule } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/modules/SerializersModuleBuilders.mjs';
import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { DescriptorSchemaCache22yqwocbp420v as DescriptorSchemaCache } from './internal/SchemaCache.mjs';
import { JsonToStringWriter25agxcyem0yhk as JsonToStringWriter } from './internal/JsonToStringWriterJsWasm.mjs';
import { encodeByWriter108llwage8l5s as encodeByWriter } from './internal/JsonStreams.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { StringJsonLexer3eu6xom7mrcfu as StringJsonLexer } from './internal/StringJsonLexer.mjs';
import { WriteMode_OBJ_getInstance22t89c05u2uu8 as WriteMode_OBJ_getInstance } from './internal/WriteMode.mjs';
import { StreamingJsonDecoderyo05rsghf9i6 as StreamingJsonDecoder } from './internal/StreamingJsonDecoder.mjs';
import { StringFormat2r2ka8mzcb3mi as StringFormat } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerialFormat.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  toString1pkumu07cwy4m as toString,
  equals2au1ep9vhcato as equals,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { _Char___init__impl__6a9atx2gndcvjvc5pke as _Char___init__impl__6a9atx } from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { JsonSerializersModuleValidator1v682i122jgoa as JsonSerializersModuleValidator } from './internal/JsonSerializersModuleValidator.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DefaultClass;
function Default() {
  if (DefaultClass === VOID) {
    class $ extends Json() {
      constructor() {
        Default_instance = null;
        super(new (JsonConfiguration())(), EmptySerializersModule());
        Default_instance = this;
      }
    }
    initMetadataForObject($, 'Default');
    DefaultClass = $;
  }
  return DefaultClass;
}
var Default_instance;
function Default_getInstance() {
  if (Default_instance === VOID)
    new (Default())();
  return Default_instance;
}
var JsonClass;
function Json() {
  if (JsonClass === VOID) {
    class $ {
      constructor(configuration, serializersModule) {
        Default_getInstance();
        this.l2m_1 = configuration;
        this.m2m_1 = serializersModule;
        this.n2m_1 = new (DescriptorSchemaCache())();
      }
      y1r() {
        return this.m2m_1;
      }
      z1n(serializer, value) {
        var result = new (JsonToStringWriter())();
        try {
          encodeByWriter(this, result, serializer, value);
          return result.toString();
        }finally {
          result.p2m();
        }
      }
      a1o(deserializer, string) {
        var lexer = StringJsonLexer(this, string);
        var input = new (StreamingJsonDecoder())(this, WriteMode_OBJ_getInstance(), lexer, deserializer.s1m(), null);
        var result = input.i1r(deserializer);
        lexer.d2n();
        return result;
      }
    }
    initMetadataForClass($, 'Json', VOID, VOID, [StringFormat()]);
    JsonClass = $;
  }
  return JsonClass;
}
function Json_0(from, builderAction) {
  from = from === VOID ? Default_getInstance() : from;
  var builder = new (JsonBuilder())(from);
  builderAction(builder);
  var conf = builder.x2n();
  return new (JsonImpl())(conf, builder.v2n_1);
}
var JsonBuilderClass;
function JsonBuilder() {
  if (JsonBuilderClass === VOID) {
    class $ {
      constructor(json) {
        this.e2n_1 = json.l2m_1.y2n_1;
        this.f2n_1 = json.l2m_1.d2o_1;
        this.g2n_1 = json.l2m_1.z2n_1;
        this.h2n_1 = json.l2m_1.a2o_1;
        this.i2n_1 = json.l2m_1.c2o_1;
        this.j2n_1 = json.l2m_1.e2o_1;
        this.k2n_1 = json.l2m_1.f2o_1;
        this.l2n_1 = json.l2m_1.h2o_1;
        this.m2n_1 = json.l2m_1.o2o_1;
        this.n2n_1 = json.l2m_1.j2o_1;
        this.o2n_1 = json.l2m_1.k2o_1;
        this.p2n_1 = json.l2m_1.l2o_1;
        this.q2n_1 = json.l2m_1.m2o_1;
        this.r2n_1 = json.l2m_1.n2o_1;
        this.s2n_1 = json.l2m_1.i2o_1;
        this.t2n_1 = json.l2m_1.b2o_1;
        this.u2n_1 = json.l2m_1.g2o_1;
        this.v2n_1 = json.y1r();
        this.w2n_1 = json.l2m_1.p2o_1;
      }
      x2n() {
        if (this.u2n_1) {
          // Inline function 'kotlin.require' call
          if (!(this.l2n_1 === 'type')) {
            var message = 'Class discriminator should not be specified when array polymorphism is specified';
            throw IllegalArgumentException().n2(toString(message));
          }
          // Inline function 'kotlin.require' call
          if (!this.m2n_1.equals(ClassDiscriminatorMode_POLYMORPHIC_getInstance())) {
            var message_0 = 'useArrayPolymorphism option can only be used if classDiscriminatorMode in a default POLYMORPHIC state.';
            throw IllegalArgumentException().n2(toString(message_0));
          }
        }
        if (!this.i2n_1) {
          // Inline function 'kotlin.require' call
          if (!(this.j2n_1 === '    ')) {
            var message_1 = 'Indent should not be specified when default printing mode is used';
            throw IllegalArgumentException().n2(toString(message_1));
          }
        } else if (!(this.j2n_1 === '    ')) {
          var tmp0 = this.j2n_1;
          var tmp$ret$6;
          $l$block: {
            // Inline function 'kotlin.text.all' call
            var inductionVariable = 0;
            while (inductionVariable < charSequenceLength(tmp0)) {
              var element = charSequenceGet(tmp0, inductionVariable);
              inductionVariable = inductionVariable + 1 | 0;
              if (!(element === _Char___init__impl__6a9atx(32) || element === _Char___init__impl__6a9atx(9) || element === _Char___init__impl__6a9atx(13) || element === _Char___init__impl__6a9atx(10))) {
                tmp$ret$6 = false;
                break $l$block;
              }
            }
            tmp$ret$6 = true;
          }
          var allWhitespaces = tmp$ret$6;
          // Inline function 'kotlin.require' call
          if (!allWhitespaces) {
            var message_2 = 'Only whitespace, tab, newline and carriage return are allowed as pretty print symbols. Had ' + this.j2n_1;
            throw IllegalArgumentException().n2(toString(message_2));
          }
        }
        return new (JsonConfiguration())(this.e2n_1, this.g2n_1, this.h2n_1, this.t2n_1, this.i2n_1, this.f2n_1, this.j2n_1, this.k2n_1, this.u2n_1, this.l2n_1, this.s2n_1, this.n2n_1, this.o2n_1, this.p2n_1, this.q2n_1, this.r2n_1, this.m2n_1, this.w2n_1);
      }
    }
    initMetadataForClass($, 'JsonBuilder');
    JsonBuilderClass = $;
  }
  return JsonBuilderClass;
}
function validateConfiguration($this) {
  if (equals($this.y1r(), EmptySerializersModule()))
    return Unit_instance;
  var collector = new (JsonSerializersModuleValidator())($this.l2m_1);
  $this.y1r().y27(collector);
}
var JsonImplClass;
function JsonImpl() {
  if (JsonImplClass === VOID) {
    class $ extends Json() {
      constructor(configuration, module_0) {
        super(configuration, module_0);
        validateConfiguration(this);
      }
    }
    initMetadataForClass($, 'JsonImpl');
    JsonImplClass = $;
  }
  return JsonImplClass;
}
//region block: exports
export {
  Default_getInstance as Default_getInstancejyc493d440j2,
  Json_0 as Jsonsmkyu9xjl7fv,
};
//endregion

//# sourceMappingURL=Json.mjs.map
